// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"new-password_wrapper__1xQ_f","form":"new-password_form__1OwKM"};